<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import TomListItem from './components/TomListItem';
import NewTomDialog from './components/NewTomDialog';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'TomList',
  components: {
    TomListItem,
    NewTomDialog,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Bezeichnung', value: 'name' }, { text: 'Fachverantwortlicher', value: 'responsibleUser' }, { text: 'Status', value: 'examState' }, { text: 'Aktionen', value: '' }],
      showNewTomDialog: false,
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      tomToDelete: {},
      searchTerm: '',
    };
  },
  computed: {
    ...mapState(['tomList']),
    ...mapState('tomList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('tomList', { fetchData: 'fetchTomList' }),
    ...mapActions('tomDetails', ['deleteTom']),
    onDelete(tomToDelete) {
      this.tomToDelete = tomToDelete;
      this.confirmDeletionMessage =
        `Soll die technische organisatorische Einheit ${this.tomToDelete.name} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.deleteTom(this.tomToDelete)
        .then(() => {
          this.fetchData();
          this.isConfirmDialogDisplayed = false;
        });
    },
    onSearch() {
      this.paginationParams.searchTerm = this.searchTerm;
      this.fetchData(this.paginationParams);
    },
  },
};
</script>

<template>
  <div class="tom-list">
    <template v-if="tomList.hasError">
      <p class="js-error-template ma-3">Failed to fetch tom list. Please try again!</p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewTomDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Neu</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-spacer />
        <v-flex md3 >
          <v-text-field
            v-model="searchTerm"
            label="Suche"
            height="22"
            class="caption"
            @keyup.enter="onSearch"
            @blur="onSearch"
          />
        </v-flex>
      </v-toolbar>

      <v-progress-linear
        v-if="tomList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="tomList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="tomList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="items" slot-scope="props">
          <tom-list-item :tom="props.item" :expanded="props.expanded" @delete="onDelete" />
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

    <NewTomDialog
      v-if="showNewTomDialog"
      @cancel="showNewTomDialog = false"
    />

    <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                        :message="confirmDeletionMessage"
                        :is-displayed="isConfirmDialogDisplayed" />

  </div>
</template>


<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
